import { Skeleton } from '@mantine/core'
import { ResponsiveBar } from '@nivo/bar'

import type { TimeToFirstContactMonth } from '../mockData'

import { chartTheme, formatMonth, formatDays } from './chartTheme'

// ---------------------------------------------------------------------------
// Tooltip
// ---------------------------------------------------------------------------

interface TooltipProps {
  indexValue: string | number
  value: number
}

const BarTooltip = ({ indexValue, value }: TooltipProps) => (
  <div className="rounded-lg bg-white px-3 py-2 shadow-md ring-1 ring-gray-200">
    <p className="text-xs font-medium text-gray-500">
      {formatMonth(String(indexValue))}
    </p>
    <p className="mt-1 text-sm font-medium text-gray-700">
      {formatDays(value)} avg
    </p>
  </div>
)

// ---------------------------------------------------------------------------
// Component
// ---------------------------------------------------------------------------

export interface VoEBarChartProps {
  data: TimeToFirstContactMonth[]
  loading?: boolean
}

export const VoEBarChart = ({
  data,
  loading = false,
}: VoEBarChartProps) => {
  if (loading) {
    return <Skeleton height={300} />
  }

  if (!data || data.length === 0) {
    return (
      <div className="flex h-[300px] items-center justify-center text-sm text-gray-400">
        No data available
      </div>
    )
  }

  return (
    <div className="h-[300px]">
      <ResponsiveBar
        data={data}
        keys={['avgDays']}
        indexBy="month"
        margin={{ top: 20, right: 20, bottom: 40, left: 50 }}
        padding={0.4}
        valueScale={{ type: 'linear' }}
        indexScale={{ type: 'band', round: true }}
        colors={['#1C93D7']}
        borderRadius={3}
        enableLabel={false}
        enableGridY={false}
        axisBottom={{
          tickSize: 0,
          tickPadding: 8,
          format: formatMonth,
        }}
        axisLeft={{
          tickSize: 0,
          tickPadding: 8,
          tickValues: 5,
          format: (v) => `${v}d`,
        }}
        theme={chartTheme}
        tooltip={BarTooltip}
      />
    </div>
  )
}
